var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowCircleRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.166 9.004V9c0-.028-.013-.05-.015-.077a.777.777 0 00-.048-.235c-.022-.057-.06-.102-.095-.152-.025-.036-.04-.079-.071-.112l-2.386-2.5a.833.833 0 10-1.206 1.15l1.042 1.092h-4.72a.833.833 0 100 1.667h4.655l-1.078 1.078a.832.832 0 101.178 1.178l2.5-2.5a.83.83 0 00.244-.585zM9 15.666a6.674 6.674 0 01-6.667-6.667A6.674 6.674 0 019 2.333a6.675 6.675 0 016.667 6.666A6.674 6.674 0 019 15.666zm0-15C4.405.666.667 4.404.667 8.999c0 4.595 3.738 8.334 8.333 8.334 4.595 0 8.333-3.739 8.333-8.334S13.595.666 9 .666z",
    fill: "#4E7B89"
  })));
}

export default SvgArrowCircleRight;